require('../../modules/es6.number.is-nan');
module.exports = require('../../modules/$.core').Number.isNaN;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/number/is-nan.js
// module id = 1027
// module chunks = 2